function formatDateTime(iso?: string): string {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-NG", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return iso;
  }
}

interface RateLimitedCardProps {
  retryAt?: string;
}

const RateLimitedCard = ({ retryAt }: RateLimitedCardProps) => {
  return (
    <div className="bg-white border border-stroke rounded-lg p-6 flex flex-col gap-y-4">
      <h3 className="font-clash-display font-semibold text-lg text-medium-dark-grey">
        We recently received an update request from you
      </h3>
      <p className="font-clash-display text-sm text-medium-dark-grey leading-[20px]">
        To prevent duplicate submissions, you can only submit one update
        request every 72 hours. You&apos;ll be able to submit a new request
        on{" "}
        <span className="font-semibold">
          {formatDateTime(retryAt) || "a later date"}
        </span>
        .
      </p>
    </div>
  );
};

export default RateLimitedCard;
